<div class="policy-start-date">
  <span class="policy-start-date__label">{{ label() }}</span>
  <span *ngIf="startDate()" class="policy-start-date__value">{{ startDate() | date: 'dd/MM/yyyy' }}</span>
</div>
